import { Building, Community, User } from "iconoir-react";
import React from "react";
import { getNameInCapitalize, TextWrap } from "../utils/common";
import { ASSIGNEE_TYPE } from "../utils/constants";

const PeopleTag = ({ el }) => {
    let icon = "";
    let style = "";
    switch (el?.assignee_type) {
        case ASSIGNEE_TYPE.USER:
            icon = <User height={20} width={20} />;
            style = "bg-[rgba(16,137,255,0.07)] border-primary text-primary";
            break;
        case ASSIGNEE_TYPE.GROUP:
            icon = <Community height={20} width={20} />;
            style =
                "bg-[rgba(240,137,16,0.07)] border-[#F08910] text-[#F08910]";
            break;
        case ASSIGNEE_TYPE.DEPARTMENT:
            icon = <Building height={20} width={20} />;
            style = "bg-[rgba(73,147,0,0.07)] border-[#499300] text-[#499300]";
            break;
        default:
    }
    return (
        <div
            className={` inline-flex items-center px-3 py-[6px] gap-[6px] border-[1px] rounded-2xl  ${style}`}
        >
            <span className="flex-shrink-0">{icon}</span>
            <span className="text-sm font-medium leading-[15px] inline-block max-w-[300px] overflow-hidden overflow-ellipsis whitespace-nowrap">
                {getNameInCapitalize(el?.full_name||el?.name_uppercase)}
            </span>
        </div>
    );
};

export default PeopleTag;
